const AdminFulfill = ({ data }) => {
    return (
        <div className="row">
            <h4 className="mb-8">Order Fulfill</h4>
            <div className="col-md-6">
                <div className="card text-white bg-info mb-3">
                    <div className="card-body px-4 text-white">
                        <h5 className="card-title text-white">{data.drop?.total || 0} Order Drop</h5>
                        <p>Base Cost: ${data.drop?.base_cost?.toFixed(2) || 0} / Real: ${data.drop?.real?.toFixed(2) || 0}</p>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="card text-white bg-primary mb-3">
                    <div className="card-body px-4 text-white">
                        <h5 className="card-title text-white">{data.pod?.total || 0} Order POD</h5>
                        <p>Base Cost: ${data.pod?.base_cost?.toFixed(2) || 0} / Real: ${data.pod?.real?.toFixed(2) || 0}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminFulfill;
